(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.SidebarController = (function(superClass) {
    extend(SidebarController, superClass);

    function SidebarController(scope, transitions, state, FilterService, timeout) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.timeout = timeout;
      this.defineFilterLayout = bind(this.defineFilterLayout, this);
      SidebarController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.service = FilterService;
      this.scope.service.filter_url = 'backend/portal/customers/filters';
      this.scope.service.setDefinitions(this.defineFilterLayout());
      this.scope.$on('Customers:init', (function(_this) {
        return function() {
          return _this.scope.$broadcast('Customers:run', _this.filters);
        };
      })(this));
      this.scope.$watch((function(_this) {
        return function() {
          return _this.scope.service.current_filters;
        };
      })(this), (function(_this) {
        return function(current_filters) {
          _this.filters = current_filters;
          return _this.scope.$broadcast('Customers:run', _this.filters);
        };
      })(this));
      if (this.state.current.name === 'portal.customers') {
        this.timeout((function(_this) {
          return function() {
            return _this.state.go('.fullpage', _this.state.params, {
              location: false
            });
          };
        })(this));
      }
    }

    SidebarController.prototype.defineFilterLayout = function() {
      var currentYear;
      currentYear = moment().year();
      return [
        {
          name: 'Filters',
          filters: [
            {
              name: 'years',
              display_name: 'Year',
              control_type: 'single_dropdown',
              deletable: false,
              selected_values: [
                {
                  key: currentYear,
                  value: currentYear
                }
              ]
            }, {
              name: 'crops',
              display_name: 'Crop'
            }
          ]
        }
      ];
    };

    return SidebarController;

  })(Controller);

}).call(this);
